import React from 'react'

const DataNotFound = ({ title, content, className }) => {
    return (
        <p className={`noDataFound ${className}`}>
            {
                (content) ? (
                    <>
                        {content}
                    </>
                ) : (
                    <>
                        No < span > {title} </span> Found
                    </>
                )
            }
        </p >
    )
}

export default DataNotFound
